export const joinObj = {
  id: "Waitlist",
  headline: "Know when we lauch. ",
  buttonLabel: "Join",
  imgStart: false,
  img: require("../../Assets/Images/Join-list.png").default,
  alt: "Woman with join the list poster",
};
